module.exports = __webpack_public_path__ + "media/homepage/builder-hero@4x-c8808112.png";